import SpriteSymbol from "../../../hac-ng/node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../hac-ng/node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "sd-arrow-carvet-down",
  "use": "sd-arrow-carvet-down-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol fill=\"currentColor\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"sd-arrow-carvet-down\"><path d=\"M14.501 10a.5.5 0 01.354.854l-3 3a.5.5 0 01-.708 0l-3-3A.5.5 0 018.501 10h6z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol